import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {ERASER_BRUSH} from '@PosterWhiteboard/models/draw.class';
import {useAppSelector} from '@/hooks';

export function DrawBrushSizeOption(): ReactElement<any> {
  const drawObject = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing;
  });
  const isImageGeneratingFromDrawing = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.isImageBeingGenerated;
  });

  if (!drawObject) {
    throw new Error('Draw Object is undefined');
  }

  if (!drawObject.drawBrush || (drawObject.drawBrush && !('strokeWeight' in drawObject.drawBrush))) {
    throw new Error('Property strokeWeight does not exist in drawBrush Object or drawBrush is undefined!');
  }

  const onChangeHandler = (strokeWeight: number): void => {
    void window.posterEditor?.whiteboard?.drawing.updateBrushSize(strokeWeight);
  };

  return (
    <ContextualMenuSliderOptions
      id="draw-brush-size-option"
      value={drawObject.drawBrush.strokeWeight}
      label={drawObject.drawBrush.brush === ERASER_BRUSH ? window.i18next.t('pmwjs_size') : window.i18next.t('pmwjs_draw_brush_size')}
      range={{
        min: 1,
        max: 100,
      }}
      transformDisplay={{
        min: 1,
        max: 100,
      }}
      onChange={onChangeHandler}
      isDisabled={isImageGeneratingFromDrawing}
    />
  );
}
